// Tree controller
// Recursive tree navigation menu (Ui::TreeComponent).
//
// Expand/collapse is handled natively by <details>/<summary> — no JS. This
// controller only translates a node click into a `tree:select` DOM event
// carrying the node's value, the Hotwire equivalent of React's onClick(value).
//
// The controller lives on the root <ul>; every node button/summary declares
//   data-action="click->ui--tree#select" data-ui--tree-value-param="<value>"
// Consumers listen with data-action="tree:select->their-controller#method" and
// read event.detail.value.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    const value = event.params.value
    this.dispatch("select", { detail: { value }, prefix: "tree" })
  }
}
